// Angualr imports
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

// CC-Common imports
import { IconConstants } from 'cc-common';

// Constant imports
import { Constants } from '../../../../_constants/constants';
import { StringFormatConstants } from '../../../../_constants/string-format-constants';

// Service imports
import { ServerErrorService } from '../../../../_services/shared-services/server-error.service';
import { PrecisionService } from '../../../../_services/shared-services/precision.service';
import { GLBatchService } from '../../_services/general-ledger/gl-batch.service';
import { HelperService } from '../../../../_services/shared-services/helper.service';

// Model imports
import { GLBatchSummaryResultDto } from '../../_models/general-ledger/gl-batch/gl-batch-summary-result-dto';
import { GLBatchDetailParametersDto } from '../../_models/general-ledger/gl-batch/gl-batch-detail-parameters-dto';
import { GLBatchSummaryItemResultDto } from '../../_models/general-ledger/gl-batch/gl-batch-summary-item-result-dto';
import { GLBatchSummaryParametersDto } from '../../_models/general-ledger/gl-batch/gl-batch-summary-parameters-dto';

@Component({
    selector: 'app-gl-batch-summary',
    templateUrl: './gl-batch-summary.component.html',
    styleUrls: ['./gl-batch-summary.component.scss']
})
export class GLBatchSummaryComponent implements OnInit {
    @Input() visible: boolean;
    @Input() glBatchSummaryParam: GLBatchSummaryParametersDto;
    @Output() closeGLBatchSummary = new EventEmitter<boolean>();

    loadingVisible = false;
    defaultLabelLocation = Constants.defaultFormLabelLocation;
    dateFormat = StringFormatConstants.dateFormat;
    currencyFormat: any;

    glBatchSummaryData: GLBatchSummaryResultDto = new GLBatchSummaryResultDto();

    iconClose = IconConstants.CLOSE;

    glBatchDetailParam: GLBatchDetailParametersDto = new GLBatchDetailParametersDto();
    showGLBatchDetail = false;

    constructor(
        private readonly glBatchService: GLBatchService,
        private readonly errorService: ServerErrorService,
        private readonly precisionService: PrecisionService,
        private readonly helperService: HelperService
    ) {
        this.currencyFormat = this.precisionService.getCurrencyFormat();
        this.calculateCustomSummary = this.calculateCustomSummary.bind(this);
    }

    ngOnInit() {
        if (!!this.glBatchSummaryParam) {
            this.populateGLBatchSummary();
        }
    }

    closePopup(): void {
        this.visible = false;
        this.closeGLBatchSummary.emit(false);
    }

    onAmountClick(data: GLBatchSummaryItemResultDto): void {
        if (!!data) {
            this.glBatchDetailParam.communityId = this.glBatchSummaryParam.communityId;
            this.glBatchDetailParam.managementCompanyId = this.glBatchSummaryParam.managementCompanyId;
            this.glBatchDetailParam.batchId = this.glBatchSummaryParam.batchId;
            this.glBatchDetailParam.accountingMethod = this.glBatchSummaryParam.accountingMethod;
            this.glBatchDetailParam.dimensions = this.glBatchSummaryParam.dimensions;
            this.glBatchDetailParam.glAccountNumber = data.glAccountNumber;
            this.showGLBatchDetail = true;
        }
    }

    calculateCustomSummary(e): void {
        this.helperService.calculateTotalSummary(e);
    }

    private populateGLBatchSummary(): void {
        this.loadingVisible = true;
        this.glBatchService.getGLBatchSummary(this.glBatchSummaryParam).subscribe(
            (result) => {
                this.glBatchSummaryData = result;
                this.loadingVisible = false;
            },
            (error) => {
                this.errorService.displayError(error);
                this.loadingVisible = false;
            }
        );
    }
}
